import { createSelector } from 'reselect';

import getSaleDetails from './getSaleDetails';

export default createSelector([getSaleDetails], saleDetails =>
  Boolean(saleDetails),
);
